import { UPLOAD_ERRORS } from './copy';

/** The design's stated limit, and BulkImportable::MAX_FILE_SIZE_BYTES. */
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

/**
 * Content types browsers actually send for a .csv.
 *
 * Mirrors BulkImportable::VALID_CSV_CONTENT_TYPES: Excel on Windows announces
 * one as application/vnd.ms-excel, and some browsers send nothing at all.
 */
const CSV_CONTENT_TYPES = [
  'text/csv',
  'application/csv',
  'application/vnd.ms-excel',
];

const AMBIGUOUS_CONTENT_TYPES = ['', 'application/octet-stream'];

const hasCsvExtension = (name = '') => name.toLowerCase().endsWith('.csv');

/**
 * Why this file cannot be uploaded, or null.
 *
 * Checked here as well as on the server because the design shows both answers
 * against the field the moment a file is chosen (Figma 787:76958 and 787:76974),
 * and sending 10 MB to be told it is 10 MB is precisely what that avoids. The
 * server checks again — this is a courtesy, not a control.
 */
export default function validateFile(file) {
  if (!file) return null;

  const type = file.type || '';

  if (
    !CSV_CONTENT_TYPES.includes(type) &&
    !(AMBIGUOUS_CONTENT_TYPES.includes(type) && hasCsvExtension(file.name))
  ) {
    return UPLOAD_ERRORS.wrongType;
  }

  // Size is checked second so that a large non-CSV reports the type, which is
  // the more useful of the two answers.
  if (file.size > MAX_FILE_SIZE_BYTES) return UPLOAD_ERRORS.tooLarge;

  return null;
}

/** "1.2 MB", as the mockup labels the chosen file. */
export const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
